<template>
  <div>
    <b-modal
      id="save-changes-alert"
      centered
      title="Save Changes Alert!"
      hide-footer
    >
      <h5 class="mb-1">
        You did not <strong>Save</strong> the current version you are editing!
      </h5>

      <div class="d-flex justify-content-around align-items-center">
        <b-button
          variant="success"
          @click="$emit('keep')"
        >
          Keep current version
        </b-button>
        <b-button
          variant="primary"
          @click="$emit('aware')"
        >
          I'm aware
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
  },
}
</script>
